var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.624 1.58397C12.4849 1.37533 12.2508 1.25 12 1.25C11.7492 1.25 11.5151 1.37533 11.376 1.58397L9.37596 4.58397C9.22253 4.81412 9.20823 5.11003 9.33874 5.35389C9.46926 5.59776 9.7234 5.75 10 5.75H11.25V13.9594L6.75 12.4594V10.8546C7.48296 10.5579 8 9.83934 8 9C8 7.89543 7.10457 7 6 7C4.89543 7 4 7.89543 4 9C4 9.83934 4.51704 10.5579 5.25 10.8546V13C5.25 13.3228 5.45657 13.6094 5.76283 13.7115L11.25 15.5406V16.0945C9.95608 16.4275 9 17.6021 9 19C9 20.6569 10.3431 22 12 22C13.6569 22 15 20.6569 15 19C15 17.6021 14.0439 16.4275 12.75 16.0945V13.5406L18.2372 11.7115C18.5434 11.6094 18.75 11.3228 18.75 11V9H19C19.5523 9 20 8.55228 20 8V6C20 5.44772 19.5523 5 19 5H17C16.4477 5 16 5.44772 16 6V8C16 8.55228 16.4477 9 17 9H17.25V10.4594L12.75 11.9594V5.75H14C14.2766 5.75 14.5307 5.59776 14.6613 5.35389C14.7918 5.11003 14.7775 4.81412 14.624 4.58397L12.624 1.58397Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsb);
export default __webpack_public_path__ + "static/media/usb.eb1ecf9b7dbabec493e939527896a1ed.svg";
export { ForwardRef as ReactComponent };